/* eslint-disable import/no-cycle */
import { takeLatest } from 'redux-saga/effects';
import {
  handleSaveFnoActivationData,
  handleSetuVerification,
  handleSetuVerificationStatus,
} from './fnoActivationFormHandlers';
import { saveFnoActivationData, startSetuVerification, checkSetuVerificationStatus } from './fnoActivationFormSlice';

export function* saveFnoActivationDataSaga() {
  yield takeLatest(saveFnoActivationData.type, handleSaveFnoActivationData);
}
export function* startSetuVerificationSaga() {
  yield takeLatest(startSetuVerification.type, handleSetuVerification);
}
export function* checkSetuVerificationStatusSaga() {
  yield takeLatest(checkSetuVerificationStatus.type, handleSetuVerificationStatus);
}
